module.exports = __webpack_public_path__ + "img/index-img-02.4298f590.png";